import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const AddressCommissionSchema: RegistryItem = {
	[AgreementTypeEnum.AddressCommission]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.PercentageOnAgreements,
			},
		},
		agreementFields: {
			"agreement.description": { rules: { hidden: true } },
			"agreement.costType": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
	},
};
